import { useTheme } from '@mui/material/styles';

interface CaretUpProps {
  width?: number;
  height?: number;
  className?: string;
  strokeColor?: string;
}

export default function CaretUp({ width = 24, height = 25, className, strokeColor }: CaretUpProps) {
  const theme = useTheme();
  const defaultStrokeColor = theme.palette.text.primary;
  const finalStrokeColor = strokeColor || defaultStrokeColor;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      className={className}
    >
      <path
        d="M5 15.5L11.2929 9.20711C11.6834 8.81658 12.3166 8.81658 12.7071 9.20711L19 15.5"
        stroke={finalStrokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
